import { render, staticRenderFns } from "./CreateCase.vue?vue&type=template&id=2eb9ec1b"
import script from "./CreateCase.vue?vue&type=script&lang=js"
export * from "./CreateCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports